import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { KomitentKontaktOsoba } from './komitent-kontakt-osoba';

@Component({
  selector: 'yt-komitent-kontakt-osoba-modal-update',
  templateUrl: './komitent-kontakt-osoba-modal-update.component.html'
})
export class KomitentKontaktOsobaModalUpdateComponent extends BaseModalUpdateComponent<KomitentKontaktOsoba> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentKontaktOsoba>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
